// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PartnerScoreConfig from "../../../domain/store/PartnerScoreConfig.bs.js";
import * as PartnerScoreV1CssHelper from "../../../domain/helper/PartnerScoreV1CssHelper.bs.js";

function ScoreSliderValueBox(Props) {
  var current_score = Props.current_score;
  var min_score = Props.min_score;
  var max_score = Props.max_score;
  var threshold_values = Props.threshold_values;
  var match = current_score >= 0 && current_score <= Belt_Option.getWithDefault(Belt_Float.fromString(Caml_array.get(threshold_values, 0)), 0) ? [
      Caml_array.get(PartnerScoreConfig.sliderBoxBorderColors, 0),
      Caml_array.get(PartnerScoreConfig.sliderBoxBGColors, 0)
    ] : (
      current_score >= Belt_Option.getWithDefault(Belt_Float.fromString(Caml_array.get(threshold_values, 0)), 0) && current_score <= Belt_Option.getWithDefault(Belt_Float.fromString(Caml_array.get(threshold_values, 1)), 0) ? [
          Caml_array.get(PartnerScoreConfig.sliderBoxBorderColors, 1),
          Caml_array.get(PartnerScoreConfig.sliderBoxBGColors, 1)
        ] : [
          Caml_array.get(PartnerScoreConfig.sliderBoxBorderColors, 2),
          Caml_array.get(PartnerScoreConfig.sliderBoxBGColors, 2)
        ]
    );
  var borderColor = match[0];
  return React.createElement("div", {
              className: "slider-value-box",
              style: {
                backgroundColor: match[1],
                borderColor: borderColor,
                left: PartnerScoreV1CssHelper.getSliderBoxPosition(current_score, min_score, max_score)
              }
            }, React.createElement("div", {
                  className: "slider-value",
                  style: {
                    color: borderColor
                  }
                }, String(current_score) + "%"));
}

var make = ScoreSliderValueBox;

export {
  make ,
  
}
/* react Not a pure module */
